<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            color="transparent">
            <v-card-text 
              class="pa-0"
              style="height: calc(100vh - 280px); overflow-y: auto;">
              <v-simple-table
                id="table_score">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        No
                      </th>

                      <th 
                        class="black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Indikator Yang Dinilai
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        colspan="2"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Sub Indikator
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Bobot Sub Indikator
                      </th>

                      <th 
                        class="text-center black--text body-2 font-weight-bold"
                        style="border: 0.5px solid #FFFFFF;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Bobot Indikator
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important;">1</td>
                      <td rowspan="3" style="border: 1px solid #e0e0e0 !important; border-left: 0px !important; border-top: 0px !important;">Pelaksanaan Tugas Utama</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">A. Penilaian Individu (Job Deskripsi)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Kesesuaian pekerjaan yang dilakukan dengan uraian pekerjaan</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ Number(data_table.nilai_individu).toFixed(2) }}</td>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important;">{{ Number(data_table.nilai_tugas_utama).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">B. Penilaian Atasan Langsung</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Hasil nilai kuesioner</td>
                      <td class="text-center" style="background: #ffffff; border-bottom: 1px solid #e0e0e0 !important;">{{ Number(data_table.nilai_atasan_langsung).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">C. Kedisiplinan Karyawan (Presensi)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">Jumlah Kehadiran atau presensi</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ Number(data_table.nilai_presensi).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important; border-bottom: 0px !important; background: #ffffff;">2</td>
                      <td rowspan="3" style="border: 1px solid #e0e0e0 !important; border-left: 0px !important; border-top: 0px !important; border-bottom: 0px !important;">Penunjang (Tugas Tambahan)</td>
                      <td rowspan="3" style="border-right: 1px solid #e0e0e0 !important;">Pengembangan Diri (Objektif)</td>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">1. Sertifikasi Kompetensi</td>
                      <td class="text-center" style="background: #ffffff; border-bottom: 1px solid #e0e0e0 !important;">{{ Number(data_table.nilai_sertifikasi_kompetensi).toFixed(2) }}</td>
                      <td rowspan="3" class="text-center" style="border: 1px solid #e0e0e0 !important; border-top: 0px !important; border-bottom: 0px !important; background: #ffffff;">{{ Number(data_table.nilai_pengembangan_diri).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important; border-bottom: 1px solid #e0e0e0 !important;">2. Pelatihan dengan Sertifikat</td>
                      <td class="text-center" style="border-bottom: 1px solid #e0e0e0 !important;">{{ Number(data_table.nilai_pelatihan_sertifikat).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td style="border-right: 1px solid #e0e0e0 !important;">3. Keterlibatan pegawai di lingkungan sekitar</td>
                      <td class="text-center" style="background: #ffffff;">{{ Number(data_table.nilai_keterlibatan_pegawai).toFixed(2) }}</td>
                    </tr>

                    <tr>
                      <td 
                        colspan="3" 
                        class="text-center font-weight-bold" 
                        style="border-bottom: 1px solid #e0e0e0 !important; border-left: 1px solid #e0e0e0 !important; border-right: 1px solid #fff !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Keterangan : 
                        
                        <span 
                          :class="data_table.nilai_total < 70 ? 'red--text' :
                                  (data_table.nilai_total >= 70 && data_table.nilai_total < 80) ? 'orange--text' :
                                  (data_table.nilai_total >= 80 && data_table.nilai_total < 90) ? 'blue--text' : 'green--text'">
                          {{ data_table.description }}
                        </span>
                      </td>
                      <td 
                        colspan="2" 
                        class="text-center font-weight-bold" 
                        style="border-bottom: 1px solid #e0e0e0 !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        Jumlah Bobot
                      </td>
                      <td 
                        class="text-center font-weight-bold" 
                        style="border: 1px solid #e0e0e0 !important; border-left: 1px solid #fff !important;"
                        :style="`background: ${set_color_rgb_down} !important;`">
                        {{ Number(data_table.nilai_total).toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <ValidationObserver 
                ref="form">
                <v-form
                  class="mt-6"
                  :class="form.note !== '' && form.note !== null ? 'pr-1' : ''">
                  <ValidationProvider 
                    name="Catatan" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      Catatan
                    </div>

                    <v-textarea
                      filled
                      rounded
                      dense
                      rows="8"
                      hide-details
                      :color="set_color"
                      placeholder="Contoh. Tuliskan catatan disini . . ."

                      v-model="form.note"
                      :success="form.note !== '' && form.note !== null && valid"
                      :error-messages="errors"
                      class="mb-4"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.note !== '' && form.note !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
      summary: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        data_table: {
          nilai_individu: 0,
          nilai_tugas_utama: 0,
          nilai_atasan_langsung: 0,
          nilai_presensi: 0,
          nilai_sertifikasi_kompetensi: 0,
          nilai_pelatihan_sertifikat: 0,
          nilai_keterlibatan_pegawai: 0,
          nilai_total: 0,
          description: '-'
        },

        form: {
          id: '',
          note: ''
        },

        process: {
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          id: this.summary.id
        }

        await get(`kpi_v2/score_summary/detail_summary`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            let data = res.results.data

            if (Object.keys(data).length > 0) {
              this.data_table = res.results.data

              this.form = {
                id: data.id,
                note: data.note
              }
            } else {
              this.data_table = {
                nilai_individu: 0,
                nilai_tugas_utama: 0,
                nilai_atasan_langsung: 0,
                nilai_presensi: 0,
                nilai_sertifikasi_kompetensi: 0,
                nilai_pelatihan_sertifikat: 0,
                nilai_keterlibatan_pegawai: 0,
                nilai_total: 0,
                description: '-'
              }

              this.form = {
                id: '',
                note: ''
              }
            }

            this.$emit('form', this.form)
          }
        })
      }
    }
  }
</script>